import React, { useEffect, useState } from 'react';
import Nav from '../components/Nav';
import NavMobile from '../components/NavMobile';
import {  FaGithub,FaLinkedin,FaFacebook,} from 'react-icons/fa';
import { HiOutlineMail } from 'react-icons/hi';

const Header = () => {
  const [bg, setBg] = useState(false);

  useEffect(() => {
    window.addEventListener('scroll', () => {
      return window.scrollY > 50 ? setBg(true) : setBg(false);
    });
  });

  return (
    <>
      <header
        className={`${bg ? 'bg-tertiary h-20' : 'h-24'
          } flex items-center fixed top-0 w-full text-white z-10 transition-all duration-300`}
      >
        <div className='container mx-auto h-full flex items-center justify-between'>
          {/* logo */}
          <a href='/' className='lg:pl-10'>
            <h3 className='text-2xl'>Emtiaz Emon</h3>
          </a>
          {/* nav */}
          <div className='hidden lg:block'>
            <Nav />
          </div>
          {/* nav mobile*/}
          <div className='lg:hidden'>
            <NavMobile />
          </div>
        </div>
      </header>
      {/* Social icons */}
      <div className='hidden lg:flex fixed flex-col top-[35%] left-0'>
        <ul>
          <li className='w-[132px] h-[40px] flex justify-between items-center ml-[-100px] hover:ml-[0px] duration-300 bg-[#d77220]'>
            <a
              className='flex justify-between items-center w-full text-gray-300'
              href='mailto:emtiazhossainrzs@gmail.com' target="_blank" rel="noopener noreferrer"
            >
              Email <HiOutlineMail size={30} />
            </a>
          </li>
          <li className='w-[132px] h-[40px] flex justify-between items-center ml-[-100px] hover:ml-[0px] duration-300 bg-blue-600'>
            <a
              className='flex justify-between items-center w-full text-gray-300'
              href="https://www.linkedin.com/in/emtiazhossaine2/" target="_blank" rel="noopener noreferrer"
            >
              Linkedin <FaLinkedin size={30} />
            </a>
          </li>
          <li className='w-[132px] h-[40px] flex justify-between items-center ml-[-100px] hover:ml-[0px] duration-300 bg-[#333333]'>
            <a
              className='flex justify-between items-center w-full text-gray-300'
              href="https://github.com/EmtiazHossainE2" target="_blank" rel="noopener noreferrer"
            >
              Github <FaGithub size={30} />
            </a>
          </li>
          <li className='w-[132px] h-[40px] flex justify-between items-center ml-[-100px] hover:ml-[0px] duration-300 bg-blue-600'>
            <a
              className='flex justify-between items-center w-full text-gray-300'
              href='https://www.facebook.com/EmtiazHossainE2' target="_blank" rel="noopener noreferrer"
            >
              Facebook <FaFacebook size={30} />
            </a>
          </li>
        </ul>
      </div>
    </>
  );
};

export default Header;
